import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=1f93003e&scoped=true"
var script = {}
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=1f93003e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93003e",
  null
  
)

export default component.exports